<span
  [class.completed]="componentConfig?.rowData?.[componentConfig!.checkColumn]"
  [class.not-completed]="
    !componentConfig?.rowData?.[componentConfig!.checkColumn]
  "
  [attr.data-testid]="
    componentConfig?.rowData?.[componentConfig!.checkColumn]
      ? 'qc-status-completed'
      : 'qc-status-not-completed'
  "
>
  @if (componentConfig?.rowData?.[componentConfig!.checkColumn]) {
    <mat-icon
      [class.completed-icon]="
        componentConfig?.rowData?.[componentConfig!.checkColumn]
      "
      [class.not-completed-icon]="
        !componentConfig?.rowData?.[componentConfig!.checkColumn]
      "
    >
      {{
        componentConfig?.rowData?.[componentConfig!.checkColumn]
          ? "check_circle"
          : "schedule"
      }}
    </mat-icon>
  }
  {{ componentData }}
</span>
